import * as React from 'react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { Elements, ExpandingSection } from '@tfo/common'

import './AboutBackgroundCheckIDD.scss'


const { ListItem, UnsortedList, Paragraph } = Elements
export interface AboutBackgroundCheckIDDProps {
	order: { companyName: string, checkpointTypes: Array<string> }
}

const AboutBackgroundCheckIDD = ({
	order,
	intl,
}: AboutBackgroundCheckIDDProps & WrappedComponentProps) => {

	return (
		<ExpandingSection
			caption={intl.formatMessage({
				id: 'aboutBackgroundCheck.expandingCaption',
			})}
			className="AboutBackgroundCheck">
			<Paragraph>
				{intl.formatMessage(
					{ id: 'aboutbackgroundcheck.header' },
					{ companyName: order.companyName },
				)}
			</Paragraph>
			<UnsortedList>
				{order.checkpointTypes.map((checkpointType, index) => (
					<ListItem key={index}>{intl.formatMessage({ id: `service.checkpoints.${checkpointType}` })}</ListItem>
				))}
			</UnsortedList>
			<Paragraph bold className='before-proceeding-header'>
				{intl.formatMessage({
					id: 'aboutbackgroundcheck.beforeProceeding.header',
				})}
			</Paragraph>

			<UnsortedList className='before-proceedings'>
				<ListItem className='before-proceeding-list-item'>
					<Paragraph>
						{intl.formatMessage(
							{ id: 'aboutbackgroundcheck.beforeProceeding.IDD.1' },
							{
								companyName: order.companyName,
							},
						)}
					</Paragraph>
				</ListItem>
			</UnsortedList>
			<Paragraph className='before-proceeding-footer'>
				{intl.formatMessage(
					{
						id: 'aboutbackgroundcheck.beforeProceeding.5'
					})}
			</Paragraph>
		</ExpandingSection>
	)
}

export default injectIntl(AboutBackgroundCheckIDD)
